import {useAppSelector} from "../../../store/store";
import {IChat} from "../../../store/reducers/chatReducer/chatReducer";

export const useChat = (fromUserId: number, toUserId: number, orderId: number): IChat | undefined => {
  const chatList = useAppSelector(state => state.chat.chatList);
  const myCompanyId = useAppSelector(state => state.company.oneItemObject.item.id);
  
  return chatList.find(c => {
    // Проверяем, что orderId совпадает
    if (orderId !== c.orderId) {
      return false;
    }
    
    // Если есть myCompanyId, ищем чаты, где участвует наша компания
    if (myCompanyId) {
      const isMyCompanyInChat = 
        c.fromUser.company.companyId === myCompanyId || 
        c.toUser.company.companyId === myCompanyId;
      
      if (isMyCompanyInChat) {
        return true;
      }
    }
    
    // Fallback: ищем по точному совпадению userId (для обратной совместимости)
    const searchedChatUserIdPair = [fromUserId, toUserId].sort();
    const chatUserIdPair = [c.fromUser.userId, c.toUser.userId].sort();
    
    return searchedChatUserIdPair[0] === chatUserIdPair[0]
      && searchedChatUserIdPair[1] === chatUserIdPair[1];
  });
}